import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import baseApi from "../../api/baseApi";

import { Slide, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

const initialState = {
  agreement: {},
  agreementLoading: true,
  agreementRefresh: true,

  agreementDetails: {},
  agreementDetailsLoading: true,
  agreementDetailsRefresh: true,

  agreements: [],
  agreementsLoading: true,
  agreementsRefresh: true,

  agreementsAgency: [],
  agreementsAgencyLoading: true,
  agreementsAgencyRefresh: true,

  agreementInvoice: null,
  agreementInvoiceLoading: true,
  agreementInvoiceRefresh: true,

  createAgreementLoading: false,
  updateAgreementLoading: false,
  deleteAgreementLoading: false,
  payAgreementLoading: false,
  createPayAgreementLoading: false,
  resendAgreementSmsLoading: false,
  resendAgreementInvoiceLoading: false,
  passiveAgreementLoading: false,
  payApproveAgreementLoading: false,

  serviceRecords: [],
  serviceRecordsLoading: true,
  serviceRecordsRefresh: true,

  agreementCustomers: [],
  agreementCustomersLoading: true,
  agreementCustomersRefresh: true,

  customerAgreements: [],
  customerAgreementsLoading: true,
  customerAgreementsRefresh: true,

  reamingRights: [],
  reamingRightsLoading: true,
  reamingRightsRefresh: true,

  createServiceRecordLoading: false,
  deleteServiceRecordLoading: false,
};

export const fetchAgreement = createAsyncThunk(
  "agreement/fetchAgreement",
  async (id) => {
    if (!id) throw new Error("Id bulunamadı!");

    const loadingToast = toast.loading("Yükleniyor...", {
      position: "top-center",
      transition: Slide,
    });

    try {
      const response = await baseApi.get(`/Aggreement/${id}`);

      toast.dismiss();

      return response.data.Value;
    } catch (error) {
      toast.update(loadingToast, {
        render: "Hata: " + error.response.data.Error.Description,
        type: "error",
        isLoading: false,
        autoClose: 5000,
        transition: Slide,
        hideProgressBar: true,
      });

      throw new Error(
        error.response?.data?.Error?.Description || error.response?.status
      );
    }
  }
);

export const fetchAgreementDetails = createAsyncThunk(
  "agreement/fetchAgreementDetails",
  async (id) => {
    if (!id) throw new Error("Id bulunamadı!");

    const loadingToast = toast.loading("Yükleniyor...", {
      position: "top-center",
      transition: Slide,
    });

    try {
      const response = await baseApi.get(
        `/Aggreement/GetAggreementWithUserInfo?AggreementId=${id}`
      );

      toast.dismiss();

      return response.data.Value;
    } catch (error) {
      toast.update(loadingToast, {
        render: "Hata: " + error.response.data.Error.Description,
        type: "error",
        isLoading: false,
        autoClose: 5000,
        transition: Slide,
        hideProgressBar: true,
      });

      throw new Error(
        error.response?.data?.Error?.Description || error.response?.status
      );
    }
  }
);

export const fetchAgreements = createAsyncThunk(
  "agreement/fetchAgreements",
  async () => {
    try {
      const response = await baseApi.get(`/Aggreement`);

      return response.data.Value;
    } catch (error) {
      throw new Error(
        error.response?.data?.Error?.Description || error.response?.status
      );
    }
  }
);

// pasif
export const createAgreement = createAsyncThunk(
  "agreement/createAgreement",
  async (values) => {
    if (!values) {
      throw new Error("Veri bulunamadı!");
    }

    const data = {
      id: 0,
      agreementName: values.agreementName,
      phoneNumber: values.phoneNumber,
      email: values.email,
      isActive: true,
      taxNumber: values.taxNumber.trim(),
      taxOffice: values.taxOffice,
      address: values.address,
      agencyId: values.agencyId,
    };

    const loadingToast = toast.loading("Kaydediliyor...", {
      position: "top-center",
      transition: Slide,
    });

    try {
      const response = await baseApi.post(`/Aggreement`, data);

      toast.update(loadingToast, {
        render: response.data.result,
        type: "success",
        isLoading: false,
        autoClose: 5000,
        transition: Slide,
        hideProgressBar: true,
      });

      return response.data.result;
    } catch (error) {
      toast.update(loadingToast, {
        render: "Hata: " + error.response.data.errorMessage,
        type: "error",
        isLoading: false,
        autoClose: 5000,
        transition: Slide,
        hideProgressBar: true,
      });

      throw new Error(error.response.data.errorMessage);
    }
  }
);

export const updateAgreement = createAsyncThunk(
  "agreement/updateAgreement",
  async (values) => {
    if (!values) {
      throw new Error("Veri bulunamadı!");
    }

    const data = {
      id: values.id,
      agencyId: values.agencyId,

      startDate: values.startDate,
      endDate: values.endDate,
      description: values.description,

      carCategory: values.carCategory,
      carBrand: values.carBrand,
      carModel: values.carModel,
      carPlate: values.carPlate,
      carYear: values.carYear,
    };

    const loadingToast = toast.loading("Kaydediliyor...", {
      position: "top-center",
      transition: Slide,
    });

    try {
      const response = await baseApi.put(`/Aggreement/${values.id}`, data);

      toast.update(loadingToast, {
        render: "Kaydedildi.",
        type: "success",
        isLoading: false,
        autoClose: 5000,
        transition: Slide,
        hideProgressBar: true,
      });

      return response.data;
    } catch (error) {
      toast.update(loadingToast, {
        render: error?.response.data?.Error
          ? `Hata: ${error.response.data.Error.Description}`
          : "Hata: Diğer hatalar!",
        type: "error",
        isLoading: false,
        autoClose: 5000,
        transition: Slide,
        hideProgressBar: true,
      });

      throw new Error(
        error.response?.data?.Error?.Description || error.response?.status
      );
    }
  }
);

// pasif
export const deleteAgreement = createAsyncThunk(
  "agreement/deleteAgreement",
  async (id) => {
    if (!id) throw new Error("Id bulunamadı!");

    const loadingToast = toast.loading("Kaydediliyor...", {
      position: "top-center",
      transition: Slide,
    });

    try {
      const response = await baseApi.delete(`/Aggreement/${id}`);

      toast.update(loadingToast, {
        render: response.data.result,
        type: "success",
        isLoading: false,
        autoClose: 5000,
        transition: Slide,
        hideProgressBar: true,
      });

      return response.data.result;
    } catch (error) {
      toast.update(loadingToast, {
        render: "Hata: " + error.response.data.errorMessage,
        type: "error",
        isLoading: false,
        autoClose: 5000,
        transition: Slide,
        hideProgressBar: true,
      });

      throw new Error(error.response.data.errorMessage);
    }
  }
);

export const createPayAgreement = createAsyncThunk(
  "agreement/createPayAgreement",
  async (values) => {
    if (!values) {
      throw new Error("Veri bulunamadı!");
    }

    const data = {
      cardHolderName: values.cardHolderName,
      cardNumber: values.cardNumber,
      expMonth: values.expMonth,
      expYear: values.expYear,
      cvc: values.cvc,
      installmentNumber: values.installmentNumber,
      posId: values.posId,
      plate: values.plate,
      modelYear: values.modelYear,
      usageType: values.usageType,
      brand: values.brand,
      model: values.model,
      customerName: values.customerName,
      phoneNumber: values.phoneNumber,
      email: values.email,
      taxNumber: values.taxNumber ? values.taxNumber.trim() : "",
      taxOffice: values.taxOffice,
      city: values.city,
      district: values.district,
      address: values.address,
      agencyId: values.agencyId,
      packageId: values.packageId,
      description: values.description,
      customerId: values.customerId,
      appType: "app",
      paymentType: parseInt(values.paymentType),
      isSecure: values.isSecure,
      bulkSaleId: values.bulkSaleId,
      issuedTime: values.issuedTime,
      discountRate: values.discountRate || 0,
      increaseAmount: values.increaseAmount || 0,
      priceAdjustmentType: values.priceAdjustmentType || 0,
    };

    const loadingToast = toast.loading("Lütfen bekleyin!", {
      position: "top-center",
      transition: Slide,
    });

    try {
      const response = await baseApi.post(`/Aggreement/CreateAggreement`, data);

      if (parseInt(values.paymentType) == 0) {
        if (values.isSecure) {
          document.open();
          document.write(response.data.Value);
          document.close();
        } else {
          window.location.href = response.data.Value;
        }
      }

      toast.dismiss(loadingToast);

      return response.data.Value;
    } catch (error) {
      toast.update(loadingToast, {
        render:
          "Hata: " +
          (error.response?.data?.Error?.Description || "Bir hata oluştu"),
        type: "error",
        isLoading: false,
        autoClose: 5000,
        transition: Slide,
        hideProgressBar: true,
      });

      throw new Error(
        JSON.stringify(error.response?.data?.Error) || error.response?.status
      );
    }
  }
);

export const payAgreement = createAsyncThunk(
  "agreement/payAgreement",
  async (values) => {
    if (!values) {
      throw new Error("Veri bulunamadı!");
    }

    const data = {
      cardHolderName: values.cardHolderName,
      cardNumber: values.cardNumber,
      expMonth: values.expMonth,
      expYear: values.expYear,
      cvc: values.cvc,
      installmentNumber: values.installmentNumber,
      posId: values.posId,
      agreementId: values.agreementId,
      appType: "app",
      isSecure: values.isSecure,
      paymentType: parseInt(values.paymentType),
    };

    const loadingToast = toast.loading("Lütfen bekleyin!", {
      position: "top-center",
      transition: Slide,
    });

    try {
      const response = await baseApi.post(`/Aggreement/PayAgreement`, data);

      if (parseInt(values.paymentType) == 0) {
        if (values.isSecure) {
          document.open();
          document.write(response.data.Value);
          document.close();
        } else {
          window.location.href = response.data.Value;
        }
      }

      toast.dismiss(loadingToast);

      return response.data.Value;
    } catch (error) {
      toast.update(loadingToast, {
        render: "Hata: " + error.response.data.Error.Description,
        type: "error",
        isLoading: false,
        autoClose: 5000,
        transition: Slide,
        hideProgressBar: true,
      });

      throw new Error(
        error.response?.data?.Error?.Description || error.response?.status
      );
    }
  }
);

export const resendAgreementSms = createAsyncThunk(
  "agreement/resendAgreementSms",
  async (id) => {
    if (!id) throw new Error("Id bulunamadı!");

    const loadingToast = toast.loading("Lütfen bekleyin...", {
      position: "top-center",
      transition: Slide,
    });

    try {
      const response = await baseApi.post(
        `/Aggreement/ResendAgreementSms?AgreementId=${id}`
      );

      toast.update(loadingToast, {
        render: response.data.Value,
        type: "success",
        isLoading: false,
        autoClose: 5000,
        transition: Slide,
        hideProgressBar: true,
      });

      return response.data.Value;
    } catch (error) {
      toast.update(loadingToast, {
        render: "Hata: " + error.response.data.Error.Description,
        type: "error",
        isLoading: false,
        autoClose: 5000,
        transition: Slide,
        hideProgressBar: true,
      });

      throw new Error(
        error.response?.data?.Error?.Description || error.response?.status
      );
    }
  }
);

export const resendAgreementInvoice = createAsyncThunk(
  "agreement/resendAgreementInvoice",
  async (id) => {
    if (!id) throw new Error("Id bulunamadı!");

    const loadingToast = toast.loading("Lütfen bekleyin...", {
      position: "top-center",
      transition: Slide,
    });

    try {
      const response = await baseApi.post(
        `/Aggreement/ResendAgreementInvoice?AgreementId=${id}`
      );

      toast.update(loadingToast, {
        render: response.data.Value,
        type: "success",
        isLoading: false,
        autoClose: 5000,
        transition: Slide,
        hideProgressBar: true,
      });

      return response.data.Value;
    } catch (error) {
      toast.update(loadingToast, {
        render: "Hata: " + error.response.data.Error.Description,
        type: "error",
        isLoading: false,
        autoClose: 5000,
        transition: Slide,
        hideProgressBar: true,
      });

      throw new Error(
        error.response?.data?.Error?.Description || error.response?.status
      );
    }
  }
);

export const fetchAgreementInvoice = createAsyncThunk(
  "agreement/fetchAgreementInvoice",
  async (values) => {
    if (!values) throw new Error("Veri bulunamadı!");

    const loadingToast = toast.loading("Yükleniyor...", {
      position: "top-center",
      transition: Slide,
    });

    try {
      const response = await baseApi.post(
        `/Aggreement/GetAgreementInvoice?AgreementId=${values.id}&ContentType=${values.type}`
      );

      toast.dismiss();

      const byteCharacters = atob(response.data.Value);
      const byteNumbers = new Array(byteCharacters.length)
        .fill()
        .map((_, i) => byteCharacters.charCodeAt(i));
      const byteArray = new Uint8Array(byteNumbers);
      const blob = new Blob([byteArray], { type: "application/pdf" });
      const fileURL = URL.createObjectURL(blob);

      window.open(fileURL, "_blank");

      return response.data.Value;
    } catch (error) {
      toast.update(loadingToast, {
        render: "Hata: " + error.response.data.Error.Description,
        type: "error",
        isLoading: false,
        autoClose: 5000,
        transition: Slide,
        hideProgressBar: true,
      });

      throw new Error(
        error.response?.data?.Error?.Description || error.response?.status
      );
    }
  }
);

export const passiveAgreement = createAsyncThunk(
  "agreement/passiveAgreement",
  async (values) => {
    if (!values) throw new Error("Veri bulunamadı!");

    const loadingToast = toast.loading("Lütfen bekleyin...", {
      position: "top-center",
      transition: Slide,
    });

    const data = {
      agreementId: values.agreementId,
      isActive: values.isActive,
    };

    try {
      const response = await baseApi.post(
        `/Aggreement/SetStatusAgreement`,
        data
      );

      toast.update(loadingToast, {
        render: response.data.Value,
        type: "success",
        isLoading: false,
        autoClose: 5000,
        transition: Slide,
        hideProgressBar: true,
      });

      return response.data.Value;
    } catch (error) {
      toast.update(loadingToast, {
        render: "Hata: " + error.response.data.Error.Description,
        type: "error",
        isLoading: false,
        autoClose: 5000,
        transition: Slide,
        hideProgressBar: true,
      });

      throw new Error(
        error.response?.data?.Error?.Description || error.response?.status
      );
    }
  }
);

export const payApproveAgreement = createAsyncThunk(
  "agreement/payApproveAgreement",
  async (values) => {
    if (!values) throw new Error("Veri bulunamadı!");

    const loadingToast = toast.loading("Lütfen bekleyin...", {
      position: "top-center",
      transition: Slide,
    });

    const data = {
      agreementId: values.agreementId,
      isPaid: values.isPaid,
    };

    try {
      const response = await baseApi.post(
        `/Aggreement/SetPaymentStatusAgreement`,
        data
      );

      toast.update(loadingToast, {
        render: response.data.Value,
        type: "success",
        isLoading: false,
        autoClose: 5000,
        transition: Slide,
        hideProgressBar: true,
      });

      return response.data.Value;
    } catch (error) {
      toast.update(loadingToast, {
        render: "Hata: " + error.response.data.Error.Description,
        type: "error",
        isLoading: false,
        autoClose: 5000,
        transition: Slide,
        hideProgressBar: true,
      });

      throw new Error(
        error.response?.data?.Error?.Description || error.response?.status
      );
    }
  }
);

export const fetchServiceRecords = createAsyncThunk(
  "agreement/fetchServiceRecords",
  async () => {
    try {
      const response = await baseApi.get(`/Aggreement/ServiceRecords`);

      return response.data.Value;
    } catch (error) {
      throw new Error(
        error.response?.data?.Error?.Description || error.response?.status
      );
    }
  }
);

export const fetchAgreementCustomers = createAsyncThunk(
  "agreement/fetchAgreementCustomers",
  async () => {
    try {
      const response = await baseApi.get(`/Aggreement/GetCustomers`);

      return response.data.Value;
    } catch (error) {
      throw new Error(
        error.response?.data?.Error?.Description || error.response?.status
      );
    }
  }
);

export const fetchCustomerAgreements = createAsyncThunk(
  "agreement/fetchCustomerAgreements",
  async (id) => {
    if (!id) throw new Error("Id bulunamadı!");

    const loadingToast = toast.loading("Yükleniyor...", {
      position: "top-center",
      transition: Slide,
    });

    try {
      const response = await baseApi.get(
        `/Aggreement/GetAgreementsByCustomer/${id}`
      );

      toast.dismiss();

      return response.data.Value;
    } catch (error) {
      toast.update(loadingToast, {
        render: "Hata: " + error.response.data.Error.Description,
        type: "error",
        isLoading: false,
        autoClose: 5000,
        transition: Slide,
        hideProgressBar: true,
      });

      throw new Error(
        error.response?.data?.Error?.Description || error.response?.status
      );
    }
  }
);

export const fetchReamingRights = createAsyncThunk(
  "agreement/fetchReamingRights",
  async (id) => {
    if (!id) throw new Error("Id bulunamadı!");

    const loadingToast = toast.loading("Yükleniyor...", {
      position: "top-center",
      transition: Slide,
    });

    try {
      const response = await baseApi.get(
        `/Aggreement/GetRemainingRights/${id}`
      );

      toast.dismiss();

      return response.data.Value;
    } catch (error) {
      toast.update(loadingToast, {
        render: "Hata: " + error.response.data.Error.Description,
        type: "error",
        isLoading: false,
        autoClose: 5000,
        transition: Slide,
        hideProgressBar: true,
      });

      throw new Error(
        error.response?.data?.Error?.Description || error.response?.status
      );
    }
  }
);

export const createServiceRecord = createAsyncThunk(
  "agreement/createServiceRecord",
  async (values) => {
    if (!values) throw new Error("Veri bulunamadı!");

    const loadingToast = toast.loading("Lütfen bekleyin...", {
      position: "top-center",
      transition: Slide,
    });

    const data = {
      aggrementNo: values.AggrementNo,
      customerId: parseInt(values.CustomerId),
      windshield: parseInt(values.Windshield),
      accident: parseInt(values.Accident),
      fault: parseInt(values.Fault),
      tire: parseInt(values.Tire),
      fuel: parseInt(values.Fuel),
      landslide: parseInt(values.Landslide),
      headlight: parseInt(values.Headlight),
      health: parseInt(values.Health),
      tired: parseInt(values.Tired),
      evFault: parseInt(values.EVFault),
      wildAnimal: parseInt(values.WildAnimal),
      description: values.Description,
      serviceAmount: values.ServiceAmount,
      dueDatetime: values.Date,
    };

    try {
      const response = await baseApi.post(`/Aggreement/ServiceRecord`, data);

      toast.update(loadingToast, {
        render: "Hizmet kaydı başarıyla oluşturuldu.",
        type: "success",
        isLoading: false,
        autoClose: 5000,
        transition: Slide,
        hideProgressBar: true,
      });

      return response.data.Value;
    } catch (error) {
      toast.update(loadingToast, {
        render: "Hata: " + error.response.data.Error.Description,
        type: "error",
        isLoading: false,
        autoClose: 5000,
        transition: Slide,
        hideProgressBar: true,
      });

      throw new Error(
        error.response?.data?.Error?.Description || error.response?.status
      );
    }
  }
);

export const deleteServiceRecord = createAsyncThunk(
  "agreement/deleteServiceRecord",
  async (id) => {
    if (!id) throw new Error("Id bulunamadı!");

    const loadingToast = toast.loading("Siliniyor...", {
      position: "top-center",
      transition: Slide,
    });

    try {
      const response = await baseApi.delete(`/Aggreement/ServiceRecord/${id}`);

      toast.update(loadingToast, {
        render: "Hizmet kaydı başarıyla silindi.",
        type: "success",
        isLoading: false,
        autoClose: 5000,
        transition: Slide,
        hideProgressBar: true,
      });

      return response.data.result;
    } catch (error) {
      toast.update(loadingToast, {
        render: "Hata: " + error.response?.data?.Error?.Description,
        type: "error",
        isLoading: false,
        autoClose: 5000,
        transition: Slide,
        hideProgressBar: true,
      });

      throw new Error(
        error.response?.data?.Error?.Description || error.response?.status
      );
    }
  }
);

export const agreementSlice = createSlice({
  name: "agreement",
  initialState: initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchAgreement.pending, (state, action) => {
        state.agreement = {};
        state.agreementLoading = true;
      })
      .addCase(fetchAgreement.fulfilled, (state, action) => {
        state.agreement = action.payload;
        state.agreementLoading = false;
      })
      .addCase(fetchAgreement.rejected, (state, action) => {
        state.agreement = {};
        state.agreementLoading = false;
      });

    builder
      .addCase(fetchAgreementDetails.pending, (state, action) => {
        state.agreementDetails = {};
        state.agreementDetailsLoading = true;
      })
      .addCase(fetchAgreementDetails.fulfilled, (state, action) => {
        state.agreementDetails = action.payload;
        state.agreementDetailsLoading = false;
      })
      .addCase(fetchAgreementDetails.rejected, (state, action) => {
        state.agreementDetails = {};
        state.agreementDetailsLoading = false;
      });

    builder
      .addCase(fetchAgreements.pending, (state, action) => {
        state.agreements = [];
        state.agreementsLoading = true;
      })
      .addCase(fetchAgreements.fulfilled, (state, action) => {
        state.agreements = action.payload;
        state.agreementsLoading = false;
      })
      .addCase(fetchAgreements.rejected, (state, action) => {
        state.agreements = [];
        state.agreementsLoading = false;
      });

    builder
      .addCase(createAgreement.pending, (state, action) => {
        state.createAgreementLoading = true;
      })
      .addCase(createAgreement.fulfilled, (state, action) => {
        state.createAgreementLoading = false;
        state.agreementsRefresh = !state.agreementsRefresh;
      })
      .addCase(createAgreement.rejected, (state, action) => {
        state.createAgreementLoading = false;
      });

    builder
      .addCase(updateAgreement.pending, (state, action) => {
        state.updateAgreementLoading = true;
      })
      .addCase(updateAgreement.fulfilled, (state, action) => {
        state.updateAgreementLoading = false;
        state.agreementsRefresh = !state.agreementsRefresh;
      })
      .addCase(updateAgreement.rejected, (state, action) => {
        state.updateAgreementLoading = false;
      });

    builder
      .addCase(deleteAgreement.pending, (state, action) => {
        state.deleteAgreementLoading = true;
      })
      .addCase(deleteAgreement.fulfilled, (state, action) => {
        state.deleteAgreementLoading = false;
        state.agreementsRefresh = !state.agreementsRefresh;
      })
      .addCase(deleteAgreement.rejected, (state, action) => {
        state.deleteAgreementLoading = false;
      });

    builder
      .addCase(payAgreement.pending, (state, action) => {
        state.payAgreementLoading = true;
      })
      .addCase(payAgreement.fulfilled, (state, action) => {
        state.payAgreementLoading = false;
        state.agreementsRefresh = !state.agreementsRefresh;
      })
      .addCase(payAgreement.rejected, (state, action) => {
        state.payAgreementLoading = false;
      });

    builder
      .addCase(createPayAgreement.pending, (state, action) => {
        state.createPayAgreementLoading = true;
      })
      .addCase(createPayAgreement.fulfilled, (state, action) => {
        state.createPayAgreementLoading = false;
      })
      .addCase(createPayAgreement.rejected, (state, action) => {
        state.createPayAgreementLoading = false;
      });

    builder
      .addCase(resendAgreementSms.pending, (state, action) => {
        state.resendAgreementSmsLoading = true;
      })
      .addCase(resendAgreementSms.fulfilled, (state, action) => {
        state.resendAgreementSmsLoading = false;
      })
      .addCase(resendAgreementSms.rejected, (state, action) => {
        state.resendAgreementSmsLoading = false;
      });

    builder
      .addCase(resendAgreementInvoice.pending, (state, action) => {
        state.resendAgreementInvoiceLoading = true;
      })
      .addCase(resendAgreementInvoice.fulfilled, (state, action) => {
        state.resendAgreementInvoiceLoading = false;
        state.agreementsRefresh = !state.agreementsRefresh;
      })
      .addCase(resendAgreementInvoice.rejected, (state, action) => {
        state.resendAgreementInvoiceLoading = false;
      });

    builder
      .addCase(fetchAgreementInvoice.pending, (state, action) => {
        state.agreementInvoice = null;
        state.agreementInvoiceLoading = true;
      })
      .addCase(fetchAgreementInvoice.fulfilled, (state, action) => {
        state.agreementInvoice = action.payload;
        state.agreementInvoiceLoading = false;
      })
      .addCase(fetchAgreementInvoice.rejected, (state, action) => {
        state.agreementInvoice = null;
        state.agreementInvoiceLoading = false;
      });

    builder
      .addCase(passiveAgreement.pending, (state, action) => {
        state.passiveAgreementLoading = true;
      })
      .addCase(passiveAgreement.fulfilled, (state, action) => {
        state.passiveAgreementLoading = false;
        state.agreementsRefresh = !state.agreementsRefresh;
      })
      .addCase(passiveAgreement.rejected, (state, action) => {
        state.passiveAgreementLoading = false;
      });

    builder
      .addCase(payApproveAgreement.pending, (state, action) => {
        state.payApproveAgreementLoading = true;
      })
      .addCase(payApproveAgreement.fulfilled, (state, action) => {
        state.payApproveAgreementLoading = false;
        state.agreementsRefresh = !state.agreementsRefresh;
      })
      .addCase(payApproveAgreement.rejected, (state, action) => {
        state.payApproveAgreementLoading = false;
      });

    builder
      .addCase(fetchServiceRecords.pending, (state, action) => {
        state.serviceRecords = [];
        state.serviceRecordsLoading = true;
      })
      .addCase(fetchServiceRecords.fulfilled, (state, action) => {
        state.serviceRecords = action.payload;
        state.serviceRecordsLoading = false;
      })
      .addCase(fetchServiceRecords.rejected, (state, action) => {
        state.serviceRecords = [];
        state.serviceRecordsLoading = false;
      });

    builder
      .addCase(fetchAgreementCustomers.pending, (state, action) => {
        state.agreementCustomers = [];
        state.agreementCustomersLoading = true;
      })
      .addCase(fetchAgreementCustomers.fulfilled, (state, action) => {
        state.agreementCustomers = action.payload;
        state.agreementCustomersLoading = false;
      })
      .addCase(fetchAgreementCustomers.rejected, (state, action) => {
        state.agreementCustomers = [];
        state.agreementCustomersLoading = false;
      });

    builder
      .addCase(fetchCustomerAgreements.pending, (state, action) => {
        state.customerAgreements = [];
        state.customerAgreementsLoading = true;
      })
      .addCase(fetchCustomerAgreements.fulfilled, (state, action) => {
        state.customerAgreements = action.payload;
        state.customerAgreementsLoading = false;
      })
      .addCase(fetchCustomerAgreements.rejected, (state, action) => {
        state.customerAgreements = [];
        state.customerAgreementsLoading = false;
      });

    builder
      .addCase(fetchReamingRights.pending, (state, action) => {
        state.reamingRights = [];
        state.reamingRightsLoading = true;
      })
      .addCase(fetchReamingRights.fulfilled, (state, action) => {
        state.reamingRights = action.payload;
        state.reamingRightsLoading = false;
      })
      .addCase(fetchReamingRights.rejected, (state, action) => {
        state.reamingRights = [];
        state.reamingRightsLoading = false;
      });

    builder
      .addCase(createServiceRecord.pending, (state, action) => {
        state.createServiceRecordLoading = true;
      })
      .addCase(createServiceRecord.fulfilled, (state, action) => {
        state.createServiceRecordLoading = false;
        state.serviceRecordsRefresh = !state.serviceRecordsRefresh;
      })
      .addCase(createServiceRecord.rejected, (state, action) => {
        state.createServiceRecordLoading = false;
      });

    builder
      .addCase(deleteServiceRecord.pending, (state, action) => {
        state.deleteServiceRecordLoading = true;
      })
      .addCase(deleteServiceRecord.fulfilled, (state, action) => {
        state.deleteServiceRecordLoading = false;
        state.serviceRecordsRefresh = !state.serviceRecordsRefresh;
      })
      .addCase(deleteServiceRecord.rejected, (state, action) => {
        state.deleteServiceRecordLoading = false;
      });
  },
});

export default agreementSlice.reducer;
